import { createSlice } from '@reduxjs/toolkit'

export const laptopSlice = createSlice({
  name: 'laptop',
  initialState: {},
  reducers: {}
})

export const reducer = laptopSlice.reducer
